import { render } from "./HeroiconsOutlineChip.vue?vue&type=template&id=cf1633ae"
const script = {}

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChip.vue"]])

export default __exports__